export const MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS = 'MAP_SETTINGS_DIRECTIONS/SET_DIRECTION_SETTINGS';
export const MAP_SETTINGS_DIRECTIONS_ADD_ROUTE = 'MAP_SETTINGS_DIRECTIONS/ADD_ROUTE';
export const MAP_SETTINGS_DIRECTIONS_REMOVE_ROUTE = 'MAP_SETTINGS_DIRECTIONS/REMOVE_ROUTE';
export const MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE = 'MAP_SETTINGS_DIRECTIONS/MODIFY_ROUTE';
export const MAP_SETTINGS_DIRECTIONS_CLEAR_ROUTES = 'MAP_SETTINGS_DIRECTIONS/CLEAR_ROUTES';
export const MAP_SETTINGS_DIRECTIONS_ADD_ROUTE_SETTING = 'MAP_SETTINGS_DIRECTIONS/ADD_ROUTE_SETTING';
